import React from "react";
import Parse from "parse";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  Menu,
  MenuItem,
  IconButton,
  Typography,
} from "@mui/material";
import FadeIn from "react-fade-in";
import { useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useRef, useEffect, useState } from "react";
import MenuIcon from "@material-ui/icons/Menu";
import { Loading } from "../../../../components";
import { useQuery, gql } from "@apollo/client";
import { useAuth } from "../../../../hooks/useAuth";

const useStyles = makeStyles((theme: any) => ({
  card: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(2),
    height: "375px",
    boxShadow: theme.shadows[4],
    borderRadius: 15,
    outlineColor: "#2c2c33",
    outlineStyle: "solid",
    outlineWidth: 1,
  },
  grid: {
    flexGrow: 1,
  },
  popover: {
    backgroundColor: theme.palette.secondary.dark,
    borderRadius: 11,
    outlineColor: "#2c2c33",
    outlineStyle: "solid",
    outlineWidth: 1,
  },
  title: {
    fontSize: 18,
    fontWeight: 500
  },
  titleFont: {
    fontWeight: 500
  },
}));

const GET_CURRENT_STATS = gql`
  query getCurrentStats($collegeId: ID!) {
    interestedStudentsOverTimes(
      last: 1
      where: { college: { have: { objectId: { equalTo: $collegeId } } } }
      order: createdAt_ASC
    ) {
      edges {
        node {
          id
          numInState
          numOutState
          numConnects
          profileVisits
          ACTavg
          SATavg
          classRankAvg
          GPAavg
        }
      }
    }
  }
`;

export default function StudentStats() {
  const theme = useTheme();
  const classes = useStyles(theme);

  const auth = useAuth();
  const popoverRef = useRef(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [anchor, setAnchor] = useState(null);
  const [sub, setSub] = useState("Interested High School Students");
  const { data, loading, error } = useQuery(GET_CURRENT_STATS, {
    variables: {
      collegeId: auth.collegeId,
    },
  });

  return (
    <FadeIn delay={100}>
      <Card style={{
        backgroundColor: theme.palette.primary.dark,
        padding: theme.spacing(2),
        height: 350,
        boxShadow: theme.shadows[4],
        borderRadius: 25,
        outlineColor: "#2c2c33",
        outlineStyle: "solid",
        outlineWidth: 1,
      }}>
        <CardHeader
          title="Student Stats"
          subheader={sub}
          titleTypographyProps={{ fontWeight: 600 }}
        />
        <CardContent>
          {loading ? (
            <Loading />
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {data?.interestedStudentsOverTimes?.edges[0]?.node.SATavg?.toFixed(
                    0
                  ) ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg SAT
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {data?.interestedStudentsOverTimes?.edges[0]?.node.ACTavg?.toFixed(
                    1
                  ) ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg ACT
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {data?.interestedStudentsOverTimes?.edges[0]?.node.GPAavg?.toFixed(
                    1
                  ) ?? "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg GPA
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography variant="h5" color="secondary" align="left">
                  {(
                    data?.interestedStudentsOverTimes?.edges[0]?.node
                      .classRankAvg * 100
                  ) > 0 ? (data?.interestedStudentsOverTimes?.edges[0]?.node
                    .classRankAvg * 100).toFixed(1) + "%" : "N/A"}
                </Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography className={classes.title} align="right" color="textSecondary">
                  Avg Rank
                </Typography>
              </Grid>
            </Grid>
          )}
        </CardContent>
      </Card>
    </FadeIn>
  );
}
